import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { GbuModel } from 'src/app/models/gbu/GbuModel';
import { IGbuModel } from 'src/app/models/interfaces/gbus/IGbuModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { GbuService } from 'src/app/services/Gbu/gbu.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';

@Component({
  selector: 'app-configuracion-gbu-editar',
  templateUrl: './configuracion-gbu-editar.component.html',
  styleUrls: ['./configuracion-gbu-editar.component.css']
})
export class ConfiguracionGbuEditarComponent implements OnInit {
  id: number = 0;
  model: IGbuModel = new GbuModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private serviceGbu: GbuService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });

    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });

    this.serviceGbu.getById(this.id).subscribe((data) => {
      this.model = data;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.serviceGbu.update(this.model).subscribe((data) => {
            this.alertDialogService.open("El GBU fue actualizado");
            this.router.navigate(['/configuracion', 'gbu']);  
          });
        }
      });
    }
  }
}
